export default {
  props: {
    therm: Object,
  },
  computed: {
    max_temp() {
      if (!this.therm || !Array.isArray(this.therm.records)) return null;
      const elements = this.therm.records.map((r) => r.value);
      return Math.max(...elements).toFixed(1);
    },
    max_date() {
      if (
        !this.therm ||
        !Array.isArray(this.therm.records) ||
        this.therm.records.length === 0
      )
        return null;
      // Trova il record con value massima
      const maxRecord = this.therm.records.reduce((acc, r) =>
        r.value > acc.value ? r : acc
      );
      return new Date(maxRecord.ts * 1000).toLocaleString();
    },
    min_temp() {
      if (!this.therm || !Array.isArray(this.therm.records)) return null;
      const elements = this.therm.records.map((r) => r.value);
      return Math.min(...elements).toFixed(1);
    },
    min_date() {
      if (
        !this.therm ||
        !Array.isArray(this.therm.records) ||
        this.therm.records.length === 0
      )
        return null;
      // Trova il record con value minima
      const minRecord = this.therm.records.reduce((acc, r) =>
        r.value < acc.value ? r : acc
      );
      return new Date(minRecord.ts * 1000).toLocaleString();
    },
    avg_temp() {
      if (!this.therm || !Array.isArray(this.therm.records)) return null;
      const sum = this.therm.records.reduce((acc, r) => acc + r.value, 0);
      return (sum / this.therm.records.length).toFixed(1);
    },
    burning_time() {
      const totalSeconds = this.therm.records
        .map((r) => r.burning_time)
        .reduce((a, b) => a + b, 0);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      return `${hours.toString().padStart(2, "0")} h e ${minutes
        .toString()
        .padStart(2, "0")} m`;
    },
    litri() {
      const totalSeconds = this.therm.records
        .map((r) => r.burning_time)
        .reduce((a, b) => a + b, 0);
      return ((totalSeconds / 3600) * (this.therm.lit_h * 3.78)).toFixed(0);
    },
    tempColor() {
      const diff = this.therm.temp_now - this.therm.setpoint;
      const mag = Math.abs(diff);
      const EPS = 1; // entro 1°C: circa uguale => verde

      // circa uguale
      if (mag <= EPS) return "green"; // green 600

      if (diff < 0) {
        // sotto setpoint => blu
        if (mag >= 6) return "indigo"; // blue 900
        if (mag >= 3) return "blue"; // blue 800
        if (mag >= 2) return "light-blue"; // blue 600
        return "cyan"; // blue 400
      }

      // sopra setpoint => arancio/rosso
      if (mag >= 6) return "deep-orange"; // red 800
      if (mag >= 3) return "orange"; // deep orange 600
      if (mag >= 2) return "amber"; // orange 600
      return "light-green"; // orange 600
    },
  },
};
